/** Recovery contract for failures while opening a Realtime voice session. */

export type VoiceAgentErrorRecovery = 'retry' | 'restart_browser'

export interface ClassifiedVoiceAgentOpenError {
  message: string
  recovery: VoiceAgentErrorRecovery
}

const IOS_CAPTURE_DEVICE_PATTERN = /No AVAudioSessionCaptureDevice device/i

/**
 * iOS 26 WebKit can lose its audio capture device after a media-services
 * reset (WebKit #319706). Retrying getUserMedia in the same page is not a
 * recovery path, so surface the actual device action instead of raw WebKit.
 */
export function classifyVoiceAgentOpenError(error: unknown): ClassifiedVoiceAgentOpenError {
  const raw = error instanceof Error ? `${error.name}: ${error.message}` : String(error)
  if (IOS_CAPTURE_DEVICE_PATTERN.test(raw)) {
    return {
      message: 'Safari hat den iPhone-Mikrofondienst verloren. Schließen Sie Safari vollständig und öffnen Sie diese Seite danach neu. Falls das Mikrofon weiterhin fehlt, starten Sie das iPhone neu.',
      recovery: 'restart_browser',
    }
  }
  return {
    message: error instanceof Error ? error.message : String(error),
    recovery: 'retry',
  }
}
